import { Group, IconButton, Paragraph, createStyles } from '@ingeniorforeningen/figurine-core';

type Props = {
  buttonClick: () => void;
  title: string;
  isScrolledToTop: boolean;
};

const styles = createStyles((theme, { isScrolledToTop }: { isScrolledToTop: boolean }) => ({
  navBar: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: isScrolledToTop
      ? theme.other.colorTokens.backgrounds.primary
      : theme.other.colorTokens.backgrounds.light,
    transition: 'background-color 100ms',
  },
}));

export const MobileHeader = ({ buttonClick, title, isScrolledToTop }: Props) => {
  const { classes } = styles({ isScrolledToTop });

  return (
    <Group className={classes.navBar} m={0} px="xl" py="xs" justify="flex-end" align="center">
      <Paragraph variant={isScrolledToTop ? 'light' : 'dark'} strong text={title} />
      <IconButton
        variant={isScrolledToTop ? 'default' : 'transparent'}
        icon="AlignRight"
        onClick={buttonClick}
      />
    </Group>
  );
};
